<div class="row">
  <div class="col">
    <p-dialog header="Header" [(visible)]="showDefectDialog" [style]="{width: '95%',}" [modal]="true"
      (onHide)="onClose()">
      <ng-template pTemplate="header" class="bg-primary">
        <div class="compare-coils m-2"><strong>Defect for coil ID :- 123456</strong></div>
      </ng-template>
      <p-splitter styleClass="mb-1 sec-h" layout="vertical" [style]="{ 'height': '99%' }">
        <ng-template pTemplate>
          <section class="px-3" style="height: 60%; margin: 1rem;">
            <div class="row mb-3">
              <div class="comparison col text-nowrap"></div>
            </div>
            <!-- Graph -->
            <div class="row">
              <div class="col">
                <div id="chartdefect">
                  <apx-chart [series]="chartOptionsDefect.series" [chart]="chartOptionsDefect.chart" [fill]="chartOptionsDefect.fill"
                    [legend]="chartOptionsDefect.legend" [plotOptions]="chartOptionsDefect.plotOptions"
                    [xaxis]="chartOptionsDefect.xaxis"></apx-chart>
                </div>
              </div>
            </div>
          </section>
        </ng-template>
      </p-splitter>
    </p-dialog>


  </div>
</div>